/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from 'react'
import { isEmpty } from 'lodash'
import dayjs from 'dayjs'
import type { PayloadPushNotificationProps } from 'modules/partial'
import type { DetailStateProps, ErrorProps } from 'modules/types'
import GLOBAL from 'modules/global'
import Notification from 'components/notification'
import {
  useGetPushNotificationDetailQuery,
  useUpdatePushNotificationMutation
} from 'store/pushNotification'
import PushNotificationForm from 'pages/pushNotification/list/form'

const Edit = ({ open, id, onClose, resyncList }: DetailStateProps & { id: string | number }) => {
  if (!open) return <></>

  const { data, isFetching, isLoading, isError, error, refetch } =
    useGetPushNotificationDetailQuery(id)
  const loading = !data && (isLoading || isFetching)
  const [updatePushNotification, update] = useUpdatePushNotificationMutation()

  const formatDate = (val: string): string =>
    !isEmpty(val) ? dayjs(val).format('YYYY/MM/DD HH:mm:ss') : ''

  const initialValues: PayloadPushNotificationProps = useMemo(() => {
    const segment: PayloadPushNotificationProps = JSON.parse(data?.segmentationJson || '{}')
    const value: PayloadPushNotificationProps = {
      id: Number(id),
      name: (data && data.name) || '',
      airingTime: formatDate((data && data.airingTime) || ''),
      memberTiers: (data && data.member) || [],
      carModel: (data && data.carModel) || [],
      carModelYear: (data && data.carModelYear) || [],
      headline: (data && data.headline) || '',
      subHeadline: (data && data.subHeadline) || '',
      ctaUrl: (data && data.ctaUrl) || '',
      image: null,
      imageUrl: (data && data.imageUrl) || null,
      targetOptions: data?.targetOptions
        ? data.targetOptions.split(',').map((s: string) => s.trim())
        : [],
      CarModelYears: (data && segment.CarModelYears) || [],
      salutation: (data && segment.salutation) || '',
      vinCsvFile: null,
      locations: (data && segment.locations) || [],
      carOwnership: (data && segment.carOwnership) || [],
      licensePlateType: (data && segment.licensePlateType) || '',
      bluelinkStatus: (data && segment.bluelinkStatus) || '',
      vinCsvFileUrl: (data && segment.vinCsvFileUrl) || null,
      activeStatus: (data && segment.activeStatus) || '',
      handoverDateRange: (data && segment.handoverDateRange) || { minDate: '', maxDate: '' }
    }

    return value
  }, [data])

  const handleSubmit = (values: FormData) => {
    updatePushNotification(values)
  }

  return (
    <>
      <PushNotificationForm
        title='Edit Push Notification'
        open={open}
        onCancel={onClose}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        isEdit
        detailLoading={loading}
        loading={update.isLoading}
      />
      <Notification
        open={!update.isLoading && !update.isUninitialized}
        onClose={() => {
          update.reset()
          if (update.isSuccess) {
            onClose()
            resyncList?.()
            refetch()
          }
        }}
        isError={Boolean(error) && isError}
        message={GLOBAL.returnExceptionMessage(isError, error as ErrorProps)}
      />
    </>
  )
}

export default Edit
